import React from "react";
import { Order } from "src/shared/services/interfacev2";

interface Props {
  selectedOrder: Order;
  getBgClass: () => string;
  isCancelled: boolean;
  isCompleted: boolean;
}

const OrderHeader: React.FC<Props> = ({ selectedOrder, getBgClass, isCancelled, isCompleted }) => {

  return (
    <div className={`${getBgClass()} rounded-t-xl px-4 py-[2px] flex-shrink-0`}>
      <div className="flex items-center justify-between">
        <div className="flex items-center justify-between gap-2">
          <h1 className="text-xl font-bold text-white">Order Details</h1>
        </div>
      </div>
    </div>
  );
};

export default OrderHeader;
